// extracted by mini-css-extract-plugin
export default {"imgdiv":"_9c1627fa19 f3ebdc8e97","img":"ed25587f41 e6009b98de"};